  export enum DATATYPE
    {
        Text,
        Double,
        Bool,
        Enum
    }